import React, { Component } from 'react';
import './LoadingScreen.css';
import { withTranslation } from "react-i18next";
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

class LoadingScreen extends Component {

    constructor(props) {
        super(props);

    }
    
    
    
    
    render() {
        const { t } = this.props;
        const dot = '.'
        let hostname = ''
        if (window.location.hostname.toString() === 'localhost'){
            hostname = 'dev'
        }
        else {
            hostname = window.location.hostname
        }
        const url = `https://${hostname}${dot}igoriacard.com/Registration/Success4`

        return (
            <div className="LoadingScreen">
                <Alert variant="filled" severity="success">
                    {t('Trwa wysyłanie wideo na serwer')}
                </Alert>
                <div style={{ textAlign: 'center', marginTop: 10 }}>
                    <CircularProgress color='success' size='200px' />
                </div>
                <Typography variant="h4" component="div" gutterBottom sx={{ color: 'success.main', mt: '1px', textAlign: 'center' }}>
                    <p>{t("Czekaj, nie zamykaj okna.")}</p>
                    <p>{t("Za chwilę nastąpi przekierowanie...")}</p>
                </Typography>
                <Typography variant="subtitle2" component="div" gutterBottom sx={{ color: 'success.main', mt: '10px', textAlign: 'center' }}>
                    <p>{t("W przeciwnym przypadku kliknij:")}</p>
                    <a href={url}>{url}</a>
                </Typography>
            </div>
        );
    }
}

export default withTranslation()(LoadingScreen);